import { SignUpForm } from "../../Comp/auth/signUp/sign-up-form";

const SignUp = () => {
  return <SignUpForm />;
};
export default SignUp;
